import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export interface AvailableSeries {
  invoicingSettingsId: number | null;
  razonSocialName: string | null;
  series: Array<{ id: number; serie: string; descripcion: string | null }>;
  defaults: Array<{ paymentMethod: string; seriesId: number }>;
}

interface SerieFolioSelectorProps {
  availableSeries: AvailableSeries | undefined;
  effectiveSerieId: number | null;
  autoSerieId: number | null;
  onChange: (serieId: number) => void;
}

// Lets the user override the folio series that gets auto-mapped from the payment method
// (e.g. force serie B for an efectivo payment because the money actually went to the bank).
// Shared by PaymentModal.tsx (Cuentas de Cobro) and PaymentValidation.tsx (Validación de
// Pago, Ticket 7) — both resolve an AvailableSeries payload from
// /api/treasury/{invoices/:id,alumnos/:id}/available-series and render it identically.
export function SerieFolioSelector({ availableSeries, effectiveSerieId, autoSerieId, onChange }: SerieFolioSelectorProps) {
  if (!availableSeries) return null;

  if (availableSeries.series.length === 0) {
    return availableSeries.invoicingSettingsId === null ? (
      <p className="text-xs text-red-600">No se pudo determinar la Razón Social de este alumno. Configura una Razón Social para su grupo o para el tenant.</p>
    ) : (
      <p className="text-xs text-red-600">Esta Razón Social no tiene ninguna serie de pago configurada. Créala en Configuración → Empresa antes de registrar el pago.</p>
    );
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="serie">Serie de Folio</Label>
      <Select value={effectiveSerieId ? String(effectiveSerieId) : ''} onValueChange={value => onChange(Number(value))}>
        <SelectTrigger>
          <SelectValue placeholder="Selecciona una serie" />
        </SelectTrigger>
        <SelectContent>
          {availableSeries.series.map(s => (
            <SelectItem key={s.id} value={String(s.id)}>
              {s.serie}{s.descripcion ? ` — ${s.descripcion}` : ''}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!autoSerieId && (
        <p className="text-xs text-amber-600">No hay serie default para esta forma de pago — selecciona una manualmente.</p>
      )}
    </div>
  );
}
